import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { Options } from '../SelectOptions';

export const Schema = Yup.object().shape({
    additionalConsentOption: Yup.string().required('Angabe ist erforderlich'),
});

export const AdditionalConsentSubForm = ({ form: { values, handleChange, touched, errors, setFieldValue } }) => {
    return (
        <>
            <Form.Group className="mb-2">
                <Form.Label>Datenfreigabe*:</Form.Label>
            </Form.Group>
                {
                    Options.AdditionalConsent.map((field, index) =>
                        <Form.Group className="mb-3" key={index}>
                            <Form.Check
                                type="radio"
                                name="additionalConsentOption"
                                id={field}
                                label={field}
                                value={1 - index}
                                feedback={errors.additionalConsentOption}
                                feedbackType="invalid"
                                isValid={touched.additionalConsentOption && !errors.additionalConsentOption}
                                isInvalid={errors.additionalConsentOption}
                                onChange={(event) => {
                                    handleChange(event);
                                }}
                            >
                            </Form.Check>
                        </Form.Group>
                    )
                }
        </>
    );
};
